import {
  Box,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack
} from '@chakra-ui/react'
import GoogleSignInButton from 'components/GoogleSignInButton'
import { authMutedColor, authTitleColor } from 'components/Layouts/AuthLayout/constants'
import { DARK_MODAL_CONTENT, DARK_MODAL_OVERLAY } from 'constants/dark-tokens'

interface AuthGoogleRequiredModalProps {
  isOpen: boolean
  onClose: () => void
  /** e.g. go back to email step or forgot-password → login */
  onSecondaryAction: () => void
  secondaryLabel: string
  redirectPath?: string
}

/**
 * Shown on small screens when the user tries email/password login or forgot-password
 * but the account is Google-only (no local password yet).
 */
const AuthGoogleRequiredModal = ({
  isOpen,
  onClose,
  onSecondaryAction,
  secondaryLabel,
  redirectPath
}: AuthGoogleRequiredModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      size="md"
      motionPreset="slideInBottom"
      closeOnOverlayClick={false}
      closeOnEsc={false}
    >
      <ModalOverlay {...DARK_MODAL_OVERLAY} />
      <ModalContent
        mx={4}
        my="auto"
        borderRadius="16px"
        maxW="400px"
        boxShadow="xl"
        {...DARK_MODAL_CONTENT}
      >
        <ModalHeader pt={8} pb={0} textAlign="center" border="none">
          <VStack spacing={4}>
            <Text fontSize="lg" fontWeight="700" color={authTitleColor} m={0} lineHeight="short">
              Let&apos;s Keep Your Account Secure
            </Text>
          </VStack>
        </ModalHeader>
        <ModalBody px={6} pt={4} pb={2}>
          <Text fontSize="sm" color={authMutedColor} textAlign="center" lineHeight="tall" m={0}>
            This email is already connected to Google Sign-In. Please sign in with Google first. You can add a password
            in your settings later.
          </Text>
        </ModalBody>
        <ModalFooter flexDirection="column" gap={3} pt={2} pb={6} px={6} border="none">
          <Box w="100%">
            <GoogleSignInButton
              redirectPath={redirectPath}
              openMyAccountForPasswordAfterLogin
              variant="primaryFilled"
            />
          </Box>
          <Link
            fontSize="sm"
            color={authMutedColor}
            fontWeight="500"
            textAlign="center"
            onClick={() => {
              onSecondaryAction()
              onClose()
            }}
            _hover={{ color: 'white' }}
          >
            {secondaryLabel}
          </Link>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default AuthGoogleRequiredModal
